import { Helmet } from "react-helmet"
import { useSelector } from "react-redux"
import { PageLanding, SectionsList } from "../components"
import { getArticles, getText } from "../redux"

function Blog() {
  const blog = useSelector(state => getText(state, "blog"))
  const articles = useSelector(getArticles)

  return (
    <div>
      <Helmet>
        <title>Blog | Agentie de Web Design - Xposed Agency</title>
        <meta
          name="description"
          content="Blog | Agentie de Web Design - Xposed Agency"
        />
      </Helmet>

      <PageLanding src={blog.mainImage} title={blog.title} />

      <SectionsList type="articles" services={articles} />
    </div>
  )
}

export default Blog
